import Image from 'next/image';
import React, { useState } from 'react';

import MaxAndMediumScreen from '@/components/Device/MaxAndMediumScreen';
import Mobile from '@/components/Device/Mobile';

import useQaList from '../hooks/useQalist';
import QaItemCard from '../QaItemCard';

const QaList = () => {
  const { faqList } = useQaList();
  const [openIndex, setOpenIndex] = useState<string>('');

  const renderContent = () => (
    <div className="flex-1">
      <div className="space-y-3 lg:space-y-5 xl:space-y-6">
        {faqList.map(({ key, answer, question }) => (
          <QaItemCard
            key={key}
            answer={answer}
            question={question}
            open={openIndex === key}
            onClick={() => setOpenIndex(openIndex === key ? '' : key)}
          />
        ))}
      </div>
    </div>
  );

  return (
    <div className="mt-20 flex w-full flex-col px-5 lg:mx-auto lg:mt-[100px] lg:w-[984px] lg:px-0 xl:mt-[140px] xl:w-[1400px]">
      <div className="flex items-start space-x-15 xl:space-x-20">
        <Mobile>{renderContent()}</Mobile>
        <MaxAndMediumScreen>
          <Image
            src="/images/faq/faq-list-1.png"
            alt=""
            width={317}
            height={422}
            className="object-cover xl:w-[451px]"
          />
          {renderContent()}
        </MaxAndMediumScreen>
      </div>
    </div>
  );
};

export default QaList;
